<div>
    <img class="center-block img-responsive" style="position:relative; transform: translateY(80%);"
        src="assets/Content/Images/Logo/FleetAtlas_CM_logo_300ppi.png" />
</div>